// extracted by mini-css-extract-plugin
export var footer = "_nu-0";
export var inherit = "_nu-1";
export var input = "_nu-2";
export var modalContent = "_nu-3";
export var quillEditor = "_nu-4";
export var subtitle = "_nu-5";